import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';

import { getFile } from '../../../../util/file.js';

import { getContentBlockItemByName } from '../../../Cms/CmsActions.js';

import PredictiveLink from '../../../Cms/components/view/PredictiveLink.js';

// "Notre sélection" category card:
// image on top (4:3), then a footer row with the uppercase label + red underline
// on the left and a circular arrow button on the right.
function PanelCategory({ panel }) {
    const { blocks } = panel || {};
    const image = getContentBlockItemByName(blocks, 'image');
    const picto = getContentBlockItemByName(blocks, 'picto');
    const link = getContentBlockItemByName(blocks, 'link');

    if(!link || !link.path) {
        return null;
    }

    return (
        <PredictiveLink
            tag="a"
            href={link.path}
            usePrefetch
            className="card h-100 position-relative border overflow-hidden text-decoration-none shadow-sm category-card"
        >
            <div className="ratio ratio-4x3 bg-info" style={{ maxHeight: '200px' }}>
                {image && image.path && (
                    <img
                        src={getFile(image.path)}
                        alt={link.text || image.text || ''}
                        className="w-100 h-100"
                        style={{ objectFit: 'cover' }}
                        loading="lazy"
                    />
                )}
            </div>
            <div className="position-absolute bottom-0 start-0 w-100 d-flex align-items-center justify-content-between gap-2 mt-n4 p-2 bg-white z-1">
                <span className="d-flex flex-column gap-2">
                    <span className={classnames('fw-bold', 'text-uppercase', 'text-dark', 'lh-lg', 'border-half-danger')} style={{ letterSpacing: '0.07em' }}>{link.text}</span>
                </span>
				<span className="d-inline-flex align-items-center justify-content-center rounded-circle bg-primary text-light flex-shrink-0" style={{ width: '34px', height: '34px', fontSize: '17px', lineHeight: 1 }}>›</span>
            </div>
			{/* {picto && picto.path && (
				<img src={getFile(picto.path)} alt={picto.text || ''} width="40" height="40" className="top-0 start-0 m-3" loading="lazy" />
			)} */}
        </PredictiveLink>
    );
}

PanelCategory.propTypes = {
    panel: PropTypes.object.isRequired,
};

export default PanelCategory;
